import DashboardLoading from 'components/skeltonLoading/Dashboard';
import {
    Route,
} from 'react-router-dom';
import { useUser } from '@appmaker/core/store/user';
import { BASE_URL } from '@appmaker/core/api/core'
import { getSsoLoginUrl } from '@appmaker/core/utils/sso';


export default function PrivateRoute({ children, ...rest }) {
    const user = useUser();
    if (user === undefined) {
        return <DashboardLoading />;
    } else if (!user.logged_in) {
        const ssoLoginUrl = getSsoLoginUrl({
            baseUrl: BASE_URL,
            returnTo: window.location.href,
            accountsUrl: process.env.REACT_APP_ACCOUNTS_URL,
        });
        window.location = ssoLoginUrl;
        return null;
    }
    return (
        <Route
            {...rest}
            render={({ location }) =>
                children
            }
        />
    );
}
